<template>
  <div>
    <v-form v-model="valid" class="d-flex align-center" style="height: 95vh">
      <v-container>
          <h1>{{ $t('resetPassword_ResetPassword') }}</h1>
        <h3>{{ $t('youLostYourPassword') }}</h3>
        <br>
        <v-row>
          <v-col cols="4" class="pa-0">
            <v-text-field label="Email" outlined :rules="emailRule" v-model="email"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pa-0">
            <v-btn :disabled="!valid" @click="resetPassword">{{ $t('sendRequest') }}</v-btn>
            <br>
            <br>
            <p v-html="$t('youRememberYourPassword')"></p>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="sentRequest" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('emailSent') }}
        </v-card-title>
        <v-card-text class="pa-4">
          {{ $t('resetePasswordRequest') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="goToLogin">{{ $t('okGoToLogin') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Repository from '../../../repositories/auth';

export default {
  name: "ResetPassword",
  data() {
    return {
      sentRequest: false,
      valid: false,
      email: '',
      emailRule: [
        e => !!e || this.$t('emailRule1'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || this.$t('emailRule2'),
      ]
    };
  },
  methods: {
    resetPassword() {
      if (this.valid) {
        Repository.resetPassword(this.email);
        this.sentRequest = true;
      }
    },
    goToLogin() {
      this.sentRequest = false;
      this.$router.push('/');
    },
  },
}
</script>

<style scoped>

</style>

